import { render } from "./RelatedCourse.vue?vue&type=template&id=d711b962"
import script from "./RelatedCourse.vue?vue&type=script&lang=js"
export * from "./RelatedCourse.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__